module.exports = __webpack_public_path__ + "img/af.d8fb0d2.svg";